// extracted by mini-css-extract-plugin
export var lightMode = "_g-0";